import { AfterViewInit, Component, Inject, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NZ_MODAL_DATA, NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ButtonList } from 'src/app/system-utils/actions-buttons/actions-buttons.component';
import { FormServices } from 'src/app/services/form.services';
import { StepDataInterface } from 'src/app/system-utils/side-panel/side-panel.component';
import { EnumColumnType, Field } from 'src/app/interfaces/field';
import { TableInterface } from '../../interfaces/table';
import { ColDef, ColumnMovedEvent, ColumnResizedEvent, ColumnState, GridApi, GridReadyEvent, IRowNode, RowClickedEvent, RowDoubleClickedEvent, RowNode } from '@ag-grid-community/core';
import { UserConfigServices } from 'src/app/services/user-config.services';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { QueryServices } from 'src/app/forms/query-executor/query-executor.component';
import { DashboardViewService } from 'src/app/services/dashboard.services';
import { DashBoardTypeEnum, GadGetInterface } from '../../interfaces/dashboard';
import { FormItemCanceling, FormItemConfiguration, FormItemEditData, FormItemSaving } from 'src/app/system-utils/form-item-component/form-item-component.component';
import { ThemeService } from 'src/app/services/theme.service';
import { LanguageServices } from 'src/app/services/LanguageServices';
import { compileFormula } from '../../safe-formula';

/*
 * Aberto via NzModalService.create({ nzData, nzViewContainerRef }) —
 * o nzViewContainerRef do dashboard garante que o DashboardViewService
 * injetado aqui seja A MESMA instância (contexto empresa/contrato).
 */
@Component({
    selector: 'table-card-configuration',
    templateUrl: './table-card-configuration.component.html',
    styleUrl: './table-card-configuration.component.scss',
    standalone: false
})
export class TableCardConfigurationComponent implements OnInit, AfterViewInit {

  private gridApi!: GridApi;
  editFace = false;
  selectedNodes: IRowNode<any>[];
  @ViewChild("outlet", { read: ViewContainerRef }) outletRef: ViewContainerRef;
  @ViewChild("content", { read: TemplateRef }) contentRef: TemplateRef<any>;

  resourceId = 'dashboard_grid_table_configuration_fields';
  formItemConfiguration: FormItemConfiguration[] = [

    {
      name: 'columnName',
      description: 'Nome da Coluna',
      title: 'Nome da Coluna',
      tooltip: 'Informar o Nome da Coluna',
      type: 'string',
      required: true
    },
    {
      name: 'columnDesc',
      description: 'Descrição da Coluna',
      title: 'Descrição da Coluna',
      tooltip: 'Informar a Descrição da Coluna',
      type: 'string',
      required: true
    },
    {
      name: 'type',
      description: 'Tipo de Campo',
      title: 'Tipo',
      tooltip: 'Informar o Tipo de Campo',
      type: 'select',
      required: true,
      options: Object.keys(JSON.parse(JSON.stringify(EnumColumnType))).filter(x => Number.parseInt(x)).map(d => {
        return { key: Number.parseInt(d), value: JSON.parse(JSON.stringify(EnumColumnType))[d] }
      })
    },
    {
      name: 'headerTooltip',
      description: 'Informação Rápida ( ToolTip )',
      title: 'Informação Rápida',
      tooltip: 'Descritivo Detalhado do Campo ao posicionar o mouse no cabecalho da grade',
      type: 'string',
      required: false
    },
    {
      name: 'order',
      description: 'Ordem',
      title: 'Ordem',
      tooltip: 'Ordem Inicial dos Campos',
      type: 'number',
      required: false
    },
    {
      name: 'hide',
      description: 'Ocultar',
      title: 'Campo Ocultado?',
      tooltip: 'Informar se o campo estará disponível para visualização ao usuário.',
      type: 'toggle',
      required: false
    },
    {
      name: 'resizable',
      description: 'Redimensionar',
      title: 'Permite Redimensionar?',
      tooltip: 'Informar se o campo poderá ser redimensionado pelo usuário.',
      type: 'toggle',
      required: false
    },
    {
      name: 'filter',
      description: 'Filtrar',
      title: 'Permite Filtrar?',
      tooltip: 'Informar se o campo poderá ser filtrado pelo usuário.',
      type: 'toggle',
      required: false
    },
    {
      name: 'isCurrency',
      description: 'É Moeda',
      title: 'Campo Moeda',
      tooltip: 'Indicar se o campo é do tipo moeda.',
      type: 'toggle',
      required: false
    },
    {
      name: 'sortable',
      description: 'Ordenar',
      title: 'Permite Ordenar?',
      tooltip: 'Informar se o campo poderá ser ordenado pelo usuário.',
      type: 'toggle',
      required: false
    },
    {
      name: 'pinned',
      description: 'Campo Travado',
      title: 'Alfinete',
      tooltip: 'Infomar se o campo está travado na direita ou esquerda',
      type: 'select',
      required: false,
      options: [
        { key: 'none', value: 'Nenhum' },
        { key: 'left', value: 'Esquerda' },
        { key: 'right', value: 'Direita' }
      ],
      optionsHideKey: true
    },
    {
      name: 'aggFunc',
      description: 'Função de Agregação',
      title: 'Função',
      tooltip: 'Informar se o campo será agregado',
      type: 'select',
      required: false,
      options: [
        { key: 'none', value: 'Nenhum' },
        { key: 'sum', value: 'Somar' },
        { key: 'min', value: 'Mínimo' },
        { key: 'max', value: 'Máximo' },
        { key: 'count', value: 'Contar' },
        { key: 'avg', value: 'Média' },
        { key: 'first', value: 'Primeiro' },
        { key: 'last', value: 'Último' }
      ],
      optionsHideKey: true
    },
    {
      name: 'width',
      description: 'Largura',
      title: 'Largura',
      tooltip: 'Largura Inicial dos Campos',
      type: 'number',
      required: false
    },
    {
      name: 'format',
      description: 'Formato',
      title: 'Formato da Célula',
      tooltip: 'Informar o Formato da Célula para campos Numero ou Data',
      type: 'string',
      required: false,
      enableDisableFunction: (data: FormGroup) => {
        if (data.get('type').value == 2 || data.get('type').value == 3 || data.get('type').value == 4) {
          return true;
        } else {
          return false;
        }
      }
    },
    {
      name: 'cellStyle',
      description: 'Estilo CSS da Célula',
      title: 'CSS da Célula',
      tooltip: 'Infomar CSS para customizar o estilo da célula',
      type: 'string',
      required: false
    },
    {
      name: 'formulaIcon',
      description: 'Fórmula para Ícone',
      title: 'Fómula para Ícone',
      tooltip: 'Infomar para Gerar um Ícone na Grade',
      type: 'string',
      required: false
    },
    {
      name: 'validationError',
      description: 'Lista de Opções',
      title: 'Infomar a Lista de Opção',
      tooltip: 'Infomar uma Lista de Opção',
      type: 'chips',
      required: false,
      enableDisableFunction: (data: FormGroup) => {
        if (data.get('type').value == EnumColumnType.Selection) {
          return true;
        } else {
          return false;
        }
      }
    }
  ];

  displayedColumns: ColDef[] = [
    {
      headerName: "Nome do Campo",
      field: "columnName",
      flex: 1,
      resizable: true
    },
    {
      headerName: "Descrição do Campo",
      field: "columnDesc",
      flex: 1,
      resizable: true
    },
    {
      headerName: "Tipo",
      field: "type",
      flex: 2,
      resizable: true,
      valueFormatter: (data: any) => {
        switch (data.value) {
          case EnumColumnType.Date: return 'Data';
          case EnumColumnType.DateTime: return 'Data/Hora';
          case EnumColumnType.Icon: return 'Icone';
          case EnumColumnType.Integer: return 'Inteiro';
          case EnumColumnType.Number: return 'Número';
          case EnumColumnType.Selection: return 'Lista de Opções';
          case EnumColumnType.Text: return 'Texto';
        }
      },
    },
    {
      headerName: "ToolTip",
      field: "headerTooltip",
      flex: 2,
      resizable: true
    },
    {
      headerName: "Ordem",
      field: "order",
      flex: 2,
      resizable: true
    },
    {
      headerName: "Ocultar",
      field: "hide",
      flex: 2,
      resizable: true
    }
  ];

  rowsField: Field[];
  form: FormGroup;
  item: TableInterface;
  stepData: StepDataInterface[] = [];
  colorDisable = true;
  editData: FormItemEditData = null;
  name: string;
  idUser: number;
  idDashBoard: number;
  tabName: string;
  type: DashBoardTypeEnum;
  newGadGet = false;
  filters: string[];
  buttonList: ButtonList[] = [];

  constructor(
    @Inject(NZ_MODAL_DATA) public dataDialog,
    public modalRef: NzModalRef,
    public formBuilder: FormBuilder,
    public formServices: FormServices,
    private message: NzMessageService,
    private modal: NzModalService,
    private userServices: UserConfigServices,
    private uas: UserAuthenticationServices,
    private qs: QueryServices,
    private dvs: DashboardViewService,
    public ThemeService: ThemeService,
    public ls: LanguageServices
  ) { }

  getRowId(params) {
    return params.data.columnName
  }

  eventGridSelect(event: RowClickedEvent) {
    this.selectedNodes = event.api.getSelectedNodes();
  }

  onGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;

    this.userServices.loadUserResource(this.uas.user.iduser, this.resourceId).subscribe({
      next: (data) => {
        const arr: Object[] = data['Mktpuserpref'];
        if (arr?.length > 0) {
          const obj = arr[0];
          if (obj['PREFERENCE'] != null) {
            const config: ColumnState[] = JSON.parse(obj['PREFERENCE']);
            this.gridApi.applyColumnState({ state: config, applyOrder: true });
          }
        }
      },
      error: () => { /* preferência de colunas é opcional */ }
    });
  }

  onQueryChange($event) {
    this.form.get('query').setValue($event);
  }

  get options() {
    return this.form.get('options') as FormGroup;
  }

  get query() {
    return this.form.get('query').value;
  }

  ngOnInit(): void {

    if (this.dataDialog.item == null) {
      this.newGadGet = true;
    }

    this.item = this.dataDialog.item == null ? {
      options: {
        canClipboard: false,
        canExport: false,
        colorLinesFormula: null,
        showPagination: false,
        fields: [],
        lastSort: []
      },
      query: "",
      title: ""
    } : this.dataDialog.item;

    this.idDashBoard = this.dataDialog.idDashBoard;
    this.idUser = this.uas.user.iduser;
    this.tabName = this.dataDialog.tabName;
    this.type = DashBoardTypeEnum.table;
    this.filters = this.dataDialog.filters != null ? this.dataDialog.filters : [];
    this.dvs.addDefaultFilters(this.filters);

    this.name = this.dataDialog.name == null ?
      this.idDashBoard + "_" + this.tabName + "_" + this.type + "_" + Date.now().toString() :
      this.dataDialog.name;

    this.rowsField = this.item.options.fields ?? [];

    this.form = this.formBuilder.group({
      title: new FormControl<string>(null, Validators.required),
      query: new FormControl<string>(null),
      refresh: new FormControl<number>(null),
      options: this.formBuilder.group({
        // controle showPagination — MESMO nome lido pelo table-card
        // (o antigo showPaginator nunca chegava ao gadget)
        showPagination: new FormControl<boolean>(false),
        canExport: new FormControl<boolean>(false),
        canClipboard: new FormControl<boolean>(false),
        colorLinesFormula: new FormControl<string>(null),
        fields: this.formBuilder.array([])
      })
    });

    this.formServices.refreshFormObject(this.form, this.item);
    this.formServices.refreshFormObject(this.form.get('options') as FormGroup, this.item.options);

    this.buttonList.push(
      {
        color: "warn",
        description: "Cancelar",
        action: () => {
          this.sair();
        }
      },
      {
        color: "primary",
        description: "Salvar",
        action: () => {
          this.okFunction();
        }
      });

    this.stepData = [
      {
        buttonList: this.buttonList,
        info: "Configurações da Tabela",
        name: "Nome",
        sideDesc: "Informações",
        title: "Informações",

      },
      {
        buttonList: this.buttonList,
        name: "query",
        sideDesc: "Query",
        title: "Consulta ao Banco de Dados",
      },
      {
        buttonList: this.buttonList,
        name: "field",
        sideDesc: "Campos",
        title: "Configuração de Campos",
      }
    ];
  }

  okFunction() {

    if (this.form.valid) {

      // valida a fórmula de cor ANTES de persistir (safe-formula §compile)
      const formula = this.options.get('colorLinesFormula').value;
      if (formula != null && formula !== '' && compileFormula(`if (params.data == null) { return; }\n${formula}`) == null) {
        this.message.error('A Expressão de Estilo das Linhas não compila. Corrija antes de salvar.');
        return;
      }

      const data: TableInterface = JSON.parse(JSON.stringify(this.form.getRawValue()));
      data.options.fields = this.rowsField;

      if (this.newGadGet) {
        const gadget: GadGetInterface = {
          gridsterItem: {
            cols: 1,
            rows: 1,
            x: 0,
            y: 0
          },
          name: this.name,
          type: this.type,
          table: data
        };

        this.modalRef.close(gadget);
      } else {
        this.modalRef.close(data);
      }

    } else {
      this.message.error(
        this.formServices.getFormErrors(this.form, [
          { colName: 'title', colDesc: 'Título' },
        ])
      );
      this.form.markAllAsTouched();
    }
  }

  printHelp() {
    this.options.get('colorLinesFormula').setValue(`if (params.node.rowIndex % 2 === 0) {
      return { background: 'red' };
    }
    if ( params.data.STATUS == "1" ) {
    return { background: '#8B0000' };
    }`
    );
  }

  add() {
    this.editFace = !this.editFace;
    this.editData = {
      index: -1,
      data: null
    };
  }

  remove() {

    const cnt = this.selectedNodes?.length ?? 0;

    if (cnt == 0) {
      this.message.warning("Nenhuma linha selecionada.");
      return;
    }

    this.modal.confirm({
      nzTitle: 'Exclusão de Dados',
      nzContent: 'Excluir os itens selecionados?',
      nzOkText: 'Excluir',
      nzOkDanger: true,
      nzCancelText: 'Cancelar',
      nzOnOk: () => {
        this.selectedNodes.forEach((rowNode: RowNode) => {
          const x = rowNode.data;
          const i = this.rowsField.findIndex(d => d['columnName'] == x['columnName']);
          if (i > -1) {
            this.rowsField.splice(i, 1);
          }
          this.gridApi.applyTransaction({ remove: [rowNode.data] });
        });
        this.selectedNodes = [];
      }
    });
  }

  onSavingArray(evento: FormItemSaving) {
    if (evento.new) {
      this.rowsField.push(evento.form.getRawValue());
      this.gridApi.applyTransaction({ add: [evento.form.getRawValue()] });
    } else {
      this.rowsField[evento.index] = evento.form.getRawValue();
      this.gridApi.applyTransaction({ update: [evento.form.getRawValue()] });
    }

    this.editFace = false;
  }

  onCanceling(_evento: FormItemCanceling) {
    this.editFace = false;
  }

  buscaFields() {

    if (this.item.options.fields?.length > 0) {
      this.modal.confirm({
        nzTitle: 'Exclusão de Campos',
        nzContent: 'Já existem campos configurados. As informações serão perdidas, deseja continuar?',
        nzOkText: 'Continuar',
        nzOkDanger: true,
        nzCancelText: 'Cancelar',
        nzOnOk: () => this.createFields()
      });
    } else {
      this.createFields();
    }
  }

  /**
   * Deriva os campos da query. Tudo acontece APÓS a resposta chegar
   * (o código antigo aplicava a transaction e recriava a view antes
   * da promise resolver — race garantido).
   */
  async createFields(): Promise<void> {
    let data: Object[];
    try {
      data = await this.qs.findNative(this.query, false, 1) as Object[];
    } catch {
      this.message.error('Falha ao executar a query para derivar os campos.');
      return;
    }

    if (data == null || data[0] == null) {
      this.message.warning('A query não retornou linhas para derivar os campos.');
      return;
    }

    this.rowsField = [];
    this.item.options.fields = [];
    Object.keys(data[0]).forEach((key, index) => {

      const value = data[0][key];
      let type = null;

      try {
        if (Date.parse(value) && !isNaN(Date.parse(value)) && (value.indexOf("-") > -1 || value.indexOf("/") > -1)) {
          type = EnumColumnType.DateTime;
        } else {
          if (parseFloat(value) === parseInt(value, 10)) {
            type = EnumColumnType.Integer;
          } else {
            if (!isNaN(parseInt(value))) {
              type = EnumColumnType.Number;
            } else {
              type = EnumColumnType.Text;
            }
          }
        }
      } catch (e) {
        type = EnumColumnType.Text;
      }

      const col: Field = {
        headerName: key,
        columnDesc: key,
        columnName: key,
        sortable: true,
        filter: true,
        resizable: true,
        headerTooltip: key,
        hide: false,
        type: type,
        width: 80,
        order: index + 1
      };

      this.item.options.fields.push(col);
      this.rowsField.push(col);
    });

    // recria a grade de campos com os dados novos, na ordem certa
    this.outletRef.clear();
    try {
      await this.dvs.removeDashBoardUserPreference(this.resourceId);
    } catch { /* preferência é opcional */ }
    this.outletRef.createEmbeddedView(this.contentRef);
  }

  ngAfterViewInit() {
    const compRef = this.outletRef.createEmbeddedView(this.contentRef);
    compRef.detectChanges();
  }

  selectRow(evento: RowDoubleClickedEvent) {
    this.editFace = true;
    this.editData = {
      data: evento.data,
      index: evento.rowIndex
    };
  }

  public onReoder(evento: ColumnMovedEvent): void {
    if (evento.finished) {
      this.userServices.saveUserResource(this.resourceId, this.uas.user.iduser, evento.api.getColumnState());
    }
  }

  public onResize(event: ColumnResizedEvent): void {
    if (event.finished) {
      this.userServices.saveUserResource(this.resourceId, this.uas.user.iduser, event.api.getColumnState());
    }
  }

  sair() {
    this.modalRef.close();
  }

}
